import {
  DetailType,
  NeutralAttackAttribute,
} from '@collector/sportsapi-client-legacy'

import { DetailConfiguration } from '../../../../composables/useSportOptions'

export enum GroupName {
  BlockedBack = 'Blocked back',
}

export const groups: Map<
  GroupName,
  DetailConfiguration<NeutralAttackAttribute>
> = new Map([
  [
    GroupName.BlockedBack,
    {
      type: DetailType.Button,
      cols: 1,
      name: GroupName.BlockedBack,
      important: false,
      attributes: [NeutralAttackAttribute.BlockedBack],
    },
  ],
])
